<template>
	<div class="non-button-table">
		<sf-data-table
			ref="dataTable"
			:paging="false"
			:columns="columns"
			:stripe="true"
			:rows="rows"
			height="70vh"
			:excel="isButton_(scrId, 'EX') || flgOsGrp"
			@changedPage="changedPage"
			@row-click="rowClick"
			:cellClassName="objCellClassName"
			index
		>
			<template v-slot:customRows="slotProps">
				<template v-if="slotProps.row.comboYn !== 'Y'">
					<template
						v-if="
							slotProps.column.property === 'x1' ||
							slotProps.column.property === 'x2' ||
							slotProps.column.property === 'x3' ||
							slotProps.column.property === 'x4' ||
							slotProps.column.property === 'x5' ||
							slotProps.column.property === 'x6' ||
							slotProps.column.property === 'x7' ||
							slotProps.column.property === 'x8' ||
							slotProps.column.property === 'x9' ||
							slotProps.column.property === 'x10'
						"
					>
						<el-input
							v-model="slotProps.row[slotProps.column.property]"
							@input="value => (slotProps.row[slotProps.column.property] = onChange2(slotProps.column.property, value))"
							maxLength="8"
							:disabled="slotProps.column.property !== 'x1' && chkDisabled"
							
						/>
					</template>
				</template>
				<template v-else>
					<!-- <template v-if="formInfo.ckuScnCd !== 'L'"> -->
					<el-select
						v-model="slotProps.row[slotProps.column.property]"
						filterable
						@change="changedRow(slotProps.row, slotProps.column.property)"
						:disabled="slotProps.column.property !== 'x1' && formInfo.ckuScnCd !== 'L'"
					>
						<!-- 선택안함 -->
						<el-option :label="getMessage_('QWCC001763')" value=""> </el-option>
						<el-option v-for="option in getIndvJgmtCdList_" :key="option.value" :label="option.label" :value="option.value"> </el-option>
					</el-select>
				</template>
			</template>

		</sf-data-table>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../store/helpers';

export default {
	props: {
		scrId: { type: String, default: '' },
		flgOsGrp: { type: Boolean, default: false },
		flgPqyapGrp: { type: Boolean, default: false },
		flgPqyrvGrp: { type: Boolean, default: false },
		flgPqyrgGrp: { type: Boolean, default: false }
	},
	mounted() {
		this.$emit('tableMounted');
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		chkDisabled() {
			if (this.formInfo.ckuScnCd === 'S') {
				return true;
			} else {
				return false;
			}
		},
		rows() {
			return this.resultList;
		},
		// 그리드 컬럼
		columns() {
			return [
				{
					label: this.getMessage_('QWCC001058'), //검사항목
					minWidth: '240px',
					headerAlign: 'center',
					children: [
						{
							label: this.getMessage_('QWCC001122'), //대분류
							prop: 'ckuPrvsCdNm',
							minWidth: '100px',
							form: {
								type: 'select',
								options: this.getCkuPrvsCdList_,
								isDisabled: ({}) => true // 에디트 방지
							}
						},
						{
							label: this.getMessage_('QWCC001123'), //소분류
							prop: 'prvsClCd',
							minWidth: '1px',
							isDisabled: ({}) => true // 에디트 방지
						},
						{
							label: this.getMessage_('QWCC001123'), //소분류명
							prop: 'prvsClNm',
							minWidth: '100px',
							isDisabled: ({}) => true // 에디트 방지
						},
						{
							label: this.getMessage_('QWCC001062'), //검사방법
							prop: 'ckuWayCdNm',
							minWidth: '80px',
							form: {
								type: 'select',
								options: this.getCkuWayCdList_,
								isDisabled: ({}) => true // 에디트 방지
							}
						}
					]
				},
				{
					label: this.getMessage_('SWCC000449'), //생산 규격
					minWidth: '240px',
					headerAlign: 'center',
					
					children: [
						{
							label: this.getMessage_('QWCC000014'), //최소값
							prop: 'nrmLlmtVal',
							maxLength: 9,
							minWidth: '75px',
							isDisabled: ({}) => true // 에디트 방지
							// isDisabled: this.speYn
						},
						{
							label: this.getMessage_('QWCC000015'), //최대값
							prop: 'nrmUplmVal',
							maxLength: 9,
							minWidth: '75px',
							isDisabled: ({}) => true // 에디트 방지
						},
						{
							label: this.getMessage_('QWCC001124'), //단위
							prop: 'utmCd',
							minWidth: '80px',
							isDisabled: ({}) => true // 에디트 방지
						}
					]
				},
				{
					label: this.getMessage_('QWCC000016'), //평균
					minWidth: '240px',
					headerAlign: 'center',
					children: [
						{
							label: 'X',
							prop: 'avgVal',
							maxLength: 9,
							minWidth: '90px',
							form: {
								type: 'number',
								validation: { maxByteSize: 8 }, //Byte단위 validation체크
								isDisabled: this.isDisabled
							}
						}
					]
				},
				{
					label: this.getMessage_('QWCC000017'), //표준편차
					minWidth: '240px',
					headerAlign: 'center',
					children: [
						{
							label: 'R',
							prop: 'stdDvatVal',
							minWidth: '90px',
							form: {
								type: 'number',
								validation: { maxByteSize: 8 }, //Byte단위 validation체크
								isDisabled: this.isDisabled
							}
						}
					]
				},
				{
					label: this.getMessage_('QWCC000018'), //공정능력
					minWidth: '240px',
					headerAlign: 'center',
					children: [
						{
							label: 'Cpk', //cpk
							prop: 'powAbltVal',
							minWidth: '90px',
							form: {
								type: 'number',
								validation: { maxByteSize: 8 }, //Byte단위 validation체크
								isDisabled: this.isDisabled
							}
						}
					]
				},
				{
					label: this.getMessage_('QWCC001125'), //결과
					prop: 'jgmtNm',
					minWidth: '90px',
					headerAlign: 'center',
					sortable: true
				},
				{
					label: 'comboYn', //콤보여부(화면제어를 위해서 필요함)
					prop: 'comboYn',
					minWidth: '1px'
				},
				{
					label: this.getMessage_('QWCC000019'), //측정치
					minWidth: '240px',
					headerAlign: 'center',
					children: [
						{
							label: 'x1', //x1
							prop: 'x1',
							minWidth: '90px',
							custom: true
							// ,
							// form: {
							// 	type: 'select',
							// 	options:[{
							// 		value: 'OK',
							// 		label: '合格'
							// 	},
							// 	{
							// 		value: 'NG',
							// 		label: '不合格'
							// 	}
							// 	],
							// 	isDisabled: this.isDisabledSi //검사구분에 따른 입력가능여부
							// }
							// ,
							// form: {
							// 	type: 'number',
							// 	maxLength: 5
							// }
							
						},
						{
							label: 'x2',
							prop: 'x2',
							minWidth: '90px',
							custom: true
							,
							// form: {
							// 	isDisabled: this.isDisabledSi //검사구분에 따른 입력가능여부
							// },
							// form: {
							// 	type: 'number',
							// 	maxLength: 5,
							// 	isDisabled: this.isDisabledSi //검사구분에 따른 입력가능여부
							// }
						},
						{
							label: 'x3',
							prop: 'x3',
							minWidth: '90px',
							custom: true
							// form: {
							// 	type: 'number',
							// 	maxLength: 5,
							// 	isDisabled: this.isDisabledSi //검사구분에 따른 입력가능여부
							// }
						},
						{
							label: 'x4',
							prop: 'x4',
							minWidth: '90px',
							custom: true
							// ,
							// form: {
							// 	type: 'number',
							// 	maxLength: 5,
							// 	isDisabled: this.isDisabledSi //검사구분에 따른 입력가능여부
							// }
						},
						{
							label: 'x5',
							prop: 'x5',
							minWidth: '90px',
							custom: true
							// ,
							// form: {
							// 	type: 'number',
							// 	maxLength: 5,
							// 	isDisabled: this.isDisabledSi //검사구분에 따른 입력가능여부
							// }
						},
						{
							label: 'x6',
							prop: 'x6',
							minWidth: '90px',
							custom: true
							// form: {
							// 	type: 'number',
							// 	maxLength: 5,
							// 	isDisabled: this.isDisabledSi //검사구분에 따른 입력가능여부
							// }
						},
						{
							label: 'x7',
							prop: 'x7',
							minWidth: '90px',
							custom: true
							// form: {
							// 	type: 'number',
							// 	maxLength: 5,
							// 	isDisabled: this.isDisabledSi //검사구분에 따른 입력가능여부
							// }
						},
						{
							label: 'x8',
							prop: 'x8',
							minWidth: '90px',
							custom: true
							// form: {
							// 	type: 'number',
							// 	maxLength: 5,
							// 	isDisabled: this.isDisabledSi //검사구분에 따른 입력가능여부
							// }
						},
						{
							label: 'x9',
							prop: 'x9',
							minWidth: '90px',
							custom: true
							// form: {
							// 	type: 'number',
							// 	maxLength: 5,
							// 	isDisabled: this.isDisabledSi //검사구분에 따른 입력가능여부
							// }
						},
						{
							label: 'x10',
							prop: 'x10',
							minWidth: '90px',
							custom: true
							// form: {
							// 	type: 'number',
							// 	maxLength: 5,
							// 	isDisabled: this.isDisabledSi //검사구분에 따른 입력가능여부
							// }
						}
					]
				}
			];
		}
		// test() {
		// 	console.log('test2');
		// 	return this.getSummaries();
		// }
	},
	// created() {
	// 	this.getSummaries();
	// },
	// watch: {
	// 	test() {
	// 		// immediate: true,
	// 		// handler: function () {
	// 		if (this.jgmtReslutList.x1 != '') {
	// 			test2();
	// 		}
	// 		// }
	// 	}
	// },
	methods: {
		...rootMethods,
		...serviceMethods,
		// isAdded: ({ row }) => row.partClCd !== 'MP',
		// isEditable({row}) {
		// 	if (this.formInfo.partClCd != 'MP') {
		// 		return false;
		// 	} else {
		// 		return true;
		// 	}
		// },
		isDisabledSample() {
			if (this.formInfo.partClCd && (this.formInfo.partClCd === 'MP' || this.formInfo.partClCd === 'AS' || this.formInfo.partClCd === '')) {
				return true;
			} else {
				return false;
			}
		},
		isDisabled({ row }) {
			if (this.formInfo.partClCd && (this.formInfo.partClCd === 'MP' || this.formInfo.partClCd === 'AS' || this.formInfo.partClCd === '')) {
				return true;
			} else {
				return false;
			}
		},
		isDisabledSi({ row }) {
			if (this.formInfo.ckuScnCd && this.formInfo.ckuScnCd === 'L') {
				return false;
			} else {
				return true;
			}
		},
		isShowSpe(payload){
			//console.log(payload, '-----------', this);
			if(payload !== 'nrmLlmtVal' && payload !== 'nrmUplmVal'){
				return false;
			}
			if(this.speYn && (isButton_(scrId, 'IP') || isButton_(scrId, 'CS'))){
				return true;
			} else{
				return true;
			}
		},
		async changedPage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || !prePageUnit) {
				//초기값 셋팅시 이미 searchBar에서 데이터를 조회했기 때문에 중복 조회 하지않도록 처리
				return;
			}
			this.setPagingInfo_({ key: 'currentPage', value: currentPageVal });
			this.setPagingInfo_({ key: 'pageUnit', value: pageUnitVal });
			this.$emit('Refresh');
		},
		saveAction() {
			this.setState_({ key: 'isSaved', value: true });
		},
		changedRow({ row, column }) {
			// console.log('select >>> ', row, column);
		},
		printAction() {},
		rowClick(row) {
			this.setState_({ key: 'selectedRow', value: row });
		},
		cellClassChange({ row, column }) {
			// :cell-class-name="test"
			if (
				column.property === 'x1' ||
				column.property === 'x2' ||
				column.property === 'x3' ||
				column.property === 'x4' ||
				column.property === 'x5' ||
				column.property === 'x6' ||
				column.property === 'x7' ||
				column.property === 'x8' ||
				column.property === 'x9' ||
				column.property === 'x10'
			) {
				// console.log(column.property);
				return 'grayClass';
			}
		},
		// x1 ~ x10까지 입력시 글자수 및 숫자만 입력가능 하도록 체크
		onChange2(key, val) {
			// console.log('sss', key, val);
			let numberRegEx = /[^-\.0-9]/g; //숫자만 입력가능(소수점 포함)
			let chkVal = val.replace(numberRegEx, '');
			// console.log('ckhVal', chkVal.length);

			if (chkVal.length > 8) {
				chkVal = chkVal.substring(0, 8);
			}

			return chkVal;
		},
		//customize table cell
		objCellClassName({ row, column }) {
			// console.log('row  >>> ', row);
			// if (row.x1Pass === 'NG' && column.property === 'x1') {
			// 	// if (row.x2Pass === 'NG' && column.property === 'x2') {
			// 	// console.log('row  >>> ', row.x2Pass, row.x2);
			// 	// if (row.x1 === 'NG' && column.property === 'prvsRsltCd') {
			// 	// console.log('row.x1Pass >>> ', row.x1Pass);
			// 	return 'rsltNg';
			// } else if (row.x6Pass === 'NG' && column.property === 'x6') {
			// 	// console.log('row.x6Pass >>> ', row.x6Pass);
			// 	return 'rsltNg';
			// }
			// return '';

			// if (row.x10Pass === 'NG' && column.property === 'x10') {
			// 	console.log('x10 >>>', row.x10Pass, column.property);
			// }

			for (let i = 1; i <= 10; i++) {
				if ((row[`x${i}Pass`] === 'NG' || row[`x${i}`] === 'NG') && column.property === `x${i}`) {
					return 'rsltNg';
				}
			}

			// for (let i = 1; i <= 10; i++) {
			// 	console.log(row[`x${i}Pass`]);
			// 	if (row[`x${i}Pass`] === 'NG' && column.property === `x${i}`) {
			// 		return 'rsltNg';
			// 	} else {
			// 		return '';
			// 	}
			// }
		}
	}
};
</script>

<style lang="scss">
.non-button-table {
	.sf-actions__right {
		position: absolute;
		top: 10px;
		right: 0px;
	}
}
.greenClass {
	background: green;
}
.redClass {
	background: red;
}
.grayClass {
	background: #f1f1f1;
}
.el-table .highlight-row {
	background: oldlace !important;
}
</style>
